import { React,useEffect, useRef, useState } from 'react';
import './styles.css';

const Pagination = ({ limit, total, offset, setOffset }) => {
  let width_page = window.innerWidth;
  let MAX_ITEMS = 9;

  if (width_page < 500) {
    MAX_ITEMS = 1;
  }

  const MAX_LEFT = (MAX_ITEMS - 1) / 2;

  const current = offset ? offset / limit + 1 : 1;
  const pages = Math.ceil(total / limit);
  const first = Math.max(current - MAX_LEFT, 1);

  function onPageChange(page) {
    setOffset((page - 1) * limit);
  }
//********************************************************* */
  const paginateRef = useRef(null);
  const[isShowing, setIsShowing] = useState(null)

  useEffect(() =>{
    const observer = new IntersectionObserver(
          ([entry]) => {
            setIsShowing(entry.isIntersecting)
          },
          {
            threshold: 0.5
          }
        );

        if (paginateRef.current){
            observer.observe(paginateRef.current)
        }

        return () =>{
          if(paginateRef.current){
            observer.unobserve(paginateRef.current)
          }
        }
  })

  return (
    <div className={`foot_pagination ${isShowing ? "onfoot" : ""}`} 
    ref={paginateRef}>
      <ul className="pagination">
        <li>
          <button
            onClick={() => onPageChange(current - 1)}
            disabled={current === 1}
          >
            Anterior
          </button>
        </li>

        {Array.from({ length: Math.min(MAX_ITEMS, pages) })
          .map((_, index) => index + first)
          .map((page) => (
            <li key={page}>
              <button
                onClick={() => onPageChange(page)}
                className={page === current ? 'pagination__item--active' : null}
              >
                {page}
              </button>
            </li>
          ))
        }

        <li>
          <button
            onClick={() => onPageChange(current + 1)}
            disabled={current === pages}
          >
            Próxima
          </button>
        </li>
      </ul>
    </div>
  );
};

export default Pagination;
